import { ShieldCheck } from '@orgus/ui/icons';
import { EnforcementSettings } from '../../standards/EnforcementSettings.tsx';
import type { SettingsSection } from '../registry.ts';

const section: SettingsSection = {
  id: 'standards',
  title: 'Standards',
  description: 'How strictly agents follow your standards while they edit.',
  order: 15,
  group: 'agents',
  keywords: ['standards', 'discipline', 'enforce', 'enforcement', 'warn', 'design rules', 'rules', 'provenance', 'landing', 'mandatory', 'advisory'],
  icon: ShieldCheck,
  Component: EnforcementSettings,
};
export default section;
